import { faCircleNotch, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import { format } from 'date-fns'
import React, { useContext, useState } from 'react'
import { useMutation } from 'react-query'
import { Swiper, SwiperSlide } from 'swiper/react'
import Context from '../../utils/Context'
import { DiaperBankPublic, DiaperBankUpdateDTO } from '../../utils/DiaperBankDTO'
import Button from '../form/Button'
import Modal from '../Modal'
import Truncate from '../Truncate'
import AddUpdate from './AddUpdate'
import UpdateManageDropdown from './UpdateManageDropdown'

export default function PublicUpdates({ diaperBank, isPublic }: { diaperBank: DiaperBankPublic; isPublic: boolean }) {
  const context = useContext(Context)
  const [expandedUpdate, setExpandedUpdate] = useState<DiaperBankUpdateDTO>()
  const [addUpdateModalOpen, setAddUpdateModalOpen] = useState(false)

  const deleteMutation = useMutation((data: { id: number }) => context.apiClient.delete<DiaperBankPublic>(`diaperBanks/${diaperBank?.slug}/updates/${data.id}`), {
    onSuccess(data) {
      context.queryClient.setQueryData([`diaperBank`, diaperBank?.slug], data)
    },
  })

  const updateMutation = useMutation(
    ({ text, isPublic, id }: { text?: string; isPublic?: boolean; id: number }) =>
      context.apiClient.put<DiaperBankPublic>(`diaperBanks/${diaperBank?.slug}/updates/${id}`, { update: { text, isPublic } }),
    {
      onSuccess(data) {
        context.queryClient.setQueryData([`diaperBank`, diaperBank?.slug], data)
      },
    },
  )

  if (isPublic && !diaperBank?.updates.length) {
    return null
  }

  const working = updateMutation.isLoading || deleteMutation.isLoading
  return (
    <>
      <div className='horizontal-line' />
      <div className='my-6'>
        {!isPublic && <AddUpdate diaperBank={diaperBank} open={addUpdateModalOpen} onClose={() => setAddUpdateModalOpen(false)} />}
        {!isPublic && !!diaperBank.updates.length && (
          <Button outline size='small' className='float-right' icon={<FontAwesomeIcon icon={faPlus} />} onClick={() => setAddUpdateModalOpen(true)}>
            Add Update
          </Button>
        )}
        <h3 className='text-lg leading-6 font-medium text-gray-900'>Updates</h3>
        {!isPublic && !diaperBank.updates.length && (
          <Button outline fullWidth className='my-4' icon={<FontAwesomeIcon icon={faPlus} />} onClick={() => setAddUpdateModalOpen(true)}>
            Add Update
          </Button>
        )}

        {expandedUpdate && (
          <Modal title={'Update'} onClose={() => setExpandedUpdate(undefined)} open={!!expandedUpdate}>
            <div>
              {expandedUpdate.imageUrl && <img src={expandedUpdate.imageUrl} className='max-w-full'></img>}
              <h5 className='text-gray-700 my-2'>{format(new Date(expandedUpdate.createdAt), 'MMMM d, yyyy')} </h5>
              {expandedUpdate.text && <div className='mt-4 text-sm  font-light'>{expandedUpdate.text}</div>}
            </div>
          </Modal>
        )}
        {!!diaperBank.updates.length && (
          <div className='px-4 my-6'>
            <Swiper slidesPerView={'auto'} pagination={false} watchOverflow={true} spaceBetween={15}>
              {diaperBank.updates?.map((update) => (
                <SwiperSlide style={{ width: '90%' }} key={update.id} className={classNames('border border-gray-700 rounded-md ', { 'opacity-40': working })}>
                  {working && (
                    <div className='centered-v-h text-white'>
                      <FontAwesomeIcon icon={faCircleNotch} spin size='4x' />
                    </div>
                  )}
                  {!isPublic && <UpdateManageDropdown update={update} deleteMutation={deleteMutation} updateMutation={updateMutation} />}
                  {update.imageUrl && <img src={`${update.imageUrl}?w=600&crop=entropy&h=600&ar=1:1&fit=crop`} className='rounded-md rounded-b-none ' />}

                  <div className='px-4 pb-4 font-thin'>
                    <h5 className='text-gray-700 my-2'>{format(new Date(update.createdAt), 'MMMM d, yyyy')} </h5>
                    {update.text && <Truncate text={update.text} lines={update.imageUrl ? 2 : 6} className='text-sm' />}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>
    </>
  )
}
